<div class="ua-Table">
	<p-table
		#mydt
		[value]="lstFacility"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedFacilities"
		dataKey="FacilityID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--Facility Name-->
				<th>
					<p-columnFilter type="text" field="FacilityName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
				<!--Facility Code-->
				<th>
					<p-columnFilter type="text" field="FacilityCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
				<!--Active-->
				<th>
					<p-columnFilter field="Active" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterStatusDesc
								[ngModel]="value"
								[options]="lstActive"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="FacilityName">Facility Name<p-sortIcon field="FacilityName"></p-sortIcon></th>
				<th pSortableColumn="FacilityCD">Facility Code<p-sortIcon field="FacilityCD"></p-sortIcon></th>
				<th pSortableColumn="Active">Active<p-sortIcon field="Active"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-facility>
			<tr [pSelectableRow]="facility">
				<td>
					<p-tableCheckbox [pSelectableRow]="facility" [value]="facility"></p-tableCheckbox>
				</td>
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ facility[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Next-->
<div class="TextCenter TopMargin">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>
